import React from "react";

export function KpiCard({ label, value, sub, icon: Icon, accent = "#08A7A0", testId, delay = 0 }) {
  return (
    <div
      data-testid={testId}
      className="gs-fade-up rounded-xl border border-slate-200 bg-white p-5 shadow-sm transition-all duration-200 hover:shadow-md hover:-translate-y-0.5"
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</p>
          <p className="mt-2 font-display text-3xl font-extrabold tracking-tight text-[#0B1F33] tabular">{value}</p>
          {sub && <p className="mt-1 text-xs text-slate-400">{sub}</p>}
        </div>
        {Icon && (
          <div className="flex h-10 w-10 items-center justify-center rounded-lg" style={{ backgroundColor: `${accent}1A` }}>
            <Icon className="h-5 w-5" style={{ color: accent }} />
          </div>
        )}
      </div>
    </div>
  );
}
